import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./FormModal.css";

function FormModal({ show, setShow, onSubmit }) {
  const [focusedField, setFocusedField] = useState(null);
  const [formData, setFormData] = useState({
    childName: "",
    childAge: "",
    phoneNumber: "",
  });
  const [errors, setErrors] = useState({});
  const handleClose = () => setShow(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.childName) newErrors.childName = true;
    if (!formData.childAge) newErrors.childAge = true;
    if (!formData.phoneNumber) newErrors.phoneNumber = true;

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    onSubmit(formData);
    handleClose();
  };

  return (
    <>
      <Modal
        show={show}
        centered
        dialogClassName="custom-modal"
        data-bs-theme="light"
        size="lg"
        onHide={handleClose}
      >
<Modal.Header closeButton>
  <div style={{ display: "flex", flexDirection: "column" }}>
    <Modal.Title style={{ lineHeight: "1.2", marginBottom: "0px" }}>
      Help Us Get To Know You
    </Modal.Title>
   </div>
</Modal.Header>

        <Modal.Body>
        <div className="sub-header">
  <span className="sub-header-text">
    Please provide details for us to personalise content
  </span>
</div>
          <Form>
            <Form.Group className="mb-2" controlId="childName">
              <Form.Label>Child's Name</Form.Label>

              <Form.Control
                type="text"
                onFocus={() => setFocusedField("childName")}
                onBlur={() => setFocusedField(null)}
                // placeholder="Enter your child's name"
                name="childName"
                value={formData.childName}
                onChange={handleInputChange}
                className={errors.childName ? "input-error" : ""}
              />
              <span
                style={{
                  display: "block",
                  fontSize: "0.875rem",
                  height: "1rem",
                  color: "gray",
                  paddingTop: "0.25rem",
                  paddingBottom: "0.25rem",
                  opacity: focusedField === "childName" ? 1 : 0,
                  transition: "opacity 0.2s ease",
                }}
              >
                What can we call your child? (Nickname works!)
              </span>
            </Form.Group>

            <Form.Group className="mb-2" controlId="childAge">
              <Form.Label>Child's Age</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Enter your child's age"
                onFocus={() => setFocusedField("childAge")}
                onBlur={() => setFocusedField(null)}
                name="childAge"
                value={formData.childAge}
                onChange={handleInputChange}
                className={errors.childAge ? "input-error" : ""}
              />
              <span
                style={{
                  display: "block",
                  fontSize: "0.875rem",
                  whiteSpace: "nowrap",
                  height: "1rem",
                  color: "gray",
                  paddingTop: "0.25rem",
                  paddingBottom: "0.25rem",
                  opacity: focusedField === "childAge" ? 1 : 0,
                  transition: "opacity 0.2s ease",
                }}
              >
                Made with love for 5–8 yr olds
              </span>
            </Form.Group>

            <Form.Group className="mb-2" controlId="phoneNumber">
              <Form.Label>Parent's Phone Number</Form.Label>
              <Form.Control
                type="tel"
                onFocus={() => setFocusedField("phoneNumber")}
                onBlur={() => setFocusedField(null)}
                // placeholder="Enter your phone number"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                className={errors.phoneNumber ? "input-error" : ""}
              />
              <span
                style={{
                  display: "block",
                  fontSize: "0.875rem",
                  height: "2rem",
                  color: "gray",
                  paddingTop: "0.25rem",
                  paddingBottom: "0.25rem",
                  opacity: focusedField === "phoneNumber" ? 1 : 0,
                  transition: "opacity 0.2s ease",
                }}
              >
                Get insights on your child's interactions
              </span>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="w-100 mb-3 d-flex justify-content-center">
          <Button onClick={handleSubmit} className="submit-button">
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default FormModal;
